import React, { useContext, useEffect, useState } from 'react';
// import { useAuth } from '../Contexts/AuthContext';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Card from '../ERUMAUI/UI_Card';
import _ from 'lodash';
import UI_Button from '../ERUMAUI/UI_Button';
import Icon_Approve from '../../Assets/Icons/Icon_Check.png';
import Icon_Reject from '../../Assets/Icons/Icon_Close.png';
import Icon_View from '../../Assets/Icons/Icon_View.png';
import Icon_Edit from '../../Assets/Icons/Icon_Edit.png';
import Icon_Delete from '../../Assets/Icons/Icon_Delete.png';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';


export default function Panel_AccountManagement_Center() {
    // const { Account, Loading } = useAuth();
    /*const [Accounts_List, Accounts_Set] = useState([]);
    const [Accounts_Loading, Loading_Set] = useState(true);
    const [Accounts_Error, Error_Set] = useState(null);
    const { Accounts_Selected, Selected_Set, Change_InProgress, Change_InProgress_Set } = Accounts_Selected_Set();
    const { Accounts_Refresh_Indicator } = useAccountsListRefresh();*/
    const {
        Accounts_List,
        Accounts_List_Set,
        Accounts_isLoading,
        Accounts_isLoading_Set,
        Accounts_Error,
        Accounts_Error_Set,
        Accounts_Selected,
        Account_Select,
        Accounts_Selected_Set,
        Accounts_ChangeInProgress,
        Accounts_ChangeInProgress_Set,
        Account_Fetch_ByID,
        Account_Update,
        Accounts_Refresh,
        Accounts_List_Approved,
        Accounts_List_Pending,
        Accounts_List_Deactivated,
        Accounts_List_Rejected,
        Accounts_Mode_Set,
        User_Role_Get,
        Pattern_Administrator,
        Pattern_Staff,
        Pattern_Teacher,
        User_Status_Get,
        Account_Approve,
        Account_Reject,
        Account_Reinstate,
        Account_Deactivate,
        Account_Reactivate,
    } = useAccounts();
    const { Time_Parse } = useScheduleManagement();
    const [Search_Mode, Search_Mode_Set] = useState(false);
    const [Search_Query, Search_Query_Set] = useState("");
    const [Search_Results, Search_Results_Set] = useState([]);
    const UI = useContext(Context_UI);

    const handleFocus = () => {
        // console.log("Input is now focused. Setting search mode to TRUE.");
        Search_Mode_Set(true);
        Search_Query_Set(UI.Element_Value_Get("AM_SearchBar"));
    };

    const handleBlur = () => {

        if (UI.Element_Value_Get("AM_SearchBar") == undefined || UI.Element_Value_Get("AM_SearchBar") == "") {
            Search_Mode_Set(false);
            // console.log("Input is now blurred. Setting search mode to FALSE.");
        }
    };

    const Accounts_List_Filtered_Pending = Accounts_List_Pending.filter(acc => {
        const searchString = `${acc.Name.First} ${acc.Name.MI}. ${acc.Name.Last}++${acc.Email}++${acc.Approval.DateApproved}`;
        return searchString.toLowerCase().includes(Search_Query.toLowerCase());
    });

    const Accounts_List_Filtered_Approved = Accounts_List_Approved.filter(acc => {
        const searchString = `${acc.Name.First} ${acc.Name.MI}. ${acc.Name.Last}++${acc.Email}++${acc.Approval.DateApproved}`;
        return searchString.toLowerCase().includes(Search_Query.toLowerCase());
    });

    const Accounts_List_Filtered_Rejected = Accounts_List_Rejected.filter(acc => {
        const searchString = `${acc.Name.First} ${acc.Name.MI}. ${acc.Name.Last}++${acc.Email}++${acc.Approval.DateApproved}`;
        return searchString.toLowerCase().includes(Search_Query.toLowerCase());
    });

    const Accounts_List_Filtered_Deactivated = Accounts_List_Deactivated.filter(acc => {
        const searchString = `${acc.Name.First} ${acc.Name.MI}. ${acc.Name.Last}++${acc.Email}++${acc.Approval.DateApproved}`;
        return searchString.toLowerCase().includes(Search_Query.toLowerCase());
    });

    const Search = () => {

    }

    const Account_Fetch = async (ID) => {
        Account_Select(ID);
    }

    const Account_Edit = async (ID) => {
        try {
            Accounts_ChangeInProgress_Set(true);
            Accounts_Mode_Set("Edit");
            const Data = await Account_Fetch_ByID(ID);
            Accounts_ChangeInProgress_Set(false);
        } catch (Error) {
            Accounts_Mode_Set(null);
            Accounts_ChangeInProgress_Set(false);
        }
    }

    const Account_Delete = async (ID) => {
        try {
            Accounts_ChangeInProgress_Set(true);
            Accounts_Mode_Set("Delete");
            const Data = await Account_Fetch_ByID(ID);
            Accounts_ChangeInProgress_Set(false);
        } catch (Error) {
            Accounts_Mode_Set(null);
            Accounts_ChangeInProgress_Set(false);
        }
    }


    /*useEffect(() => {
        Change_InProgress_Set(true);
        Accounts_GetAll()
            .then(Result => {
                Accounts_Set(Result.data);
            })
            .catch(Error => {
                console.log(Error);
                Error_Set("There was an error loading the list.");
            })
            .finally(() => {
                Loading_Set(false);
                Change_InProgress_Set(false);
            });
         window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Component updated!", "It worked.");
    }, [Accounts_Refresh_Indicator]);*/


    /*const Account_Fetch = (id) => {
        Change_InProgress_Set(true);
        Accounts_GetByID(id)
            .then(res => {
                Selected_Set(res.data._id);
                Change_InProgress_Set(false);
                window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", res.data._id, "It worked.");
                Accounts_Selected_Set(Accounts_Selected);
                console.log(Account_Selected);
            })
            .catch(err => {
                console.error("Failed to fetch account details:", err);
                Change_InProgress_Set(true);
            });
    };*/

    // if (Loading) {
    //     return null;
    // }

    if (Accounts_isLoading) {
        return <p className='General_Paragraph'> Fetching data... </p>
    }
    if (Accounts_Error) {
        return <p className='General_Paragraph'> An unexpected error occured. ({Accounts_Error})</p>
    }
    /*const Access_InteractiveMap = Account?.Access.InteractiveMap.View;
    const Access_Schedules = Account?.Access.Schedules.View;
    const Access_Reports = Account?.Access.Report.View;
    const Access_Account = Account?.Access.Account.Manage_Others;*/


    /*const Accounts_List_Approved = Accounts_List.filter(acc => acc.Approval.State === "Approved");
    const Accounts_List_Pending = Accounts_List.filter(acc => acc.Approval.State === "Pending");
    const Accounts_List_Deactivated = Accounts_List.filter(acc => acc.Approval.State === "Deactivated");
    const Accounts_List_Rejected = Accounts_List.filter(acc => acc.Approval.State === "Rejected");*/

    const Permission_CheckPattern = (Data) => {
        return User_Role_Get(Data, "List");
        if (Data.Approval.State === "Approved") {
            // console.log(Data.Access);
            // console.log(_.isEqual(Data.Access, Pattern_Teacher) + " : " + _.isEqual(Data.Access, Pattern_Staff) + " : " + _.isEqual(Data.Access, Pattern_Administrator))
            if (_.isEqual(Data.Access, Pattern_Teacher)) {
                return "Teacher";
                // console.log("Role: Teacher");
            } else if (_.isEqual(Data.Access, Pattern_Staff)) {
                return "Staff"
                // console.log("Role: Staff");
            } else if (_.isEqual(Data.Access, Pattern_Administrator)) {
                return "Administrator"
                // console.log("Role: Administrator");
            } else {
                // window.Radio_Select("Role_Custom");
                return "Custom"
            }
        }

    }

    const Table_Item = ({ Data }) => {
        if (Data) {
            return (
                <tr className='AM_Table_Row' Selected={Accounts_Selected?._id == Data._id ? "true" : "false"} onClick={() => Account_Fetch(Data._id)}>
                    <td className='AM_Table_Cell'>
                        <p className='AM_Table_Cell_Data'>
                            {Data.Name_Compounded}
                        </p>
                    </td>
                    <td className='AM_Table_Cell'>
                        <p className='AM_Table_Cell_Data'>
                            {Data.Email}
                        </p>
                    </td>
                    <td className='AM_Table_Cell'>
                        <p className='AM_Table_Cell_Data'>
                            {Time_Parse(Data.Approval.DateApproved, "Date")}
                        </p>
                    </td>
                    <td className='AM_Table_Cell'>
                        <p className='AM_Table_Cell_Data'>
                            {User_Status_Get(Data, "Approval")}
                        </p>
                    </td>
                    <td className='AM_Table_Cell'>
                        {User_Status_Get(Data, "Approval_Raw") === "Pending" ?
                            <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(Data._id)} Hover_Text="View account details" />
                                <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Approve(Data._id)} Hover_Text="Approve account request" />
                                <UI_Button Icon={Icon_Reject} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reject(Data._id)}
                                    Hover_Text="Reject account request" />
                            </UI_LinearGroup>
                            :
                            User_Status_Get(Data, "Approval_Raw") === "Rejected" || User_Status_Get(Data, "Approval_Raw") === "Deactivated" ?
                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(Data._id)} Hover_Text="View account details" />
                                    {User_Status_Get(Data, "Approval_Raw") === "Rejected" ?
                                        <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reinstate(Data._id)} Hover_Text="Reinstate this account" />
                                        :
                                        User_Status_Get(Data, "Approval_Raw") === "Deactivated" ?
                                            <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reactivate(Data._id)} Hover_Text="Reactivate this account" />    
                                        :
                                            ""
                                    }
                                    
                                </UI_LinearGroup>
                                :
                                User_Status_Get(Data, "Approval_Raw") === "Approved" ?
                                    <>
                                        <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                            <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(Data._id)} Hover_Text="View account details" />
                                            {!Data.isSystemAdmin ?
                                                <>
                                                    <UI_Button Icon={Icon_Edit} Type="Icon" Icon_Position="Center" OnClick={() => Account_Edit(Data._id)} Hover_Text="Edit account details" />
                                                    <UI_Button Icon={Icon_Reject} Type="Icon" Icon_Position="Center" OnClick={() => Account_Deactivate(Data._id)} Hover_Text="Deactivate this account" />
                                                </>
                                                :
                                                ""
                                            }

                                        </UI_LinearGroup>
                                    </>
                                    :
                                    ""
                        }

                    </td>
                </tr>
            );
        }

    }

    return (
        <div style={{ margin: "20px" }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
                {
                    Accounts_List_Pending.length > 0 ?
                        <UI_Card Shape="Rectangle" Figure={Accounts_List_Pending.length} Color="Red" Text={Accounts_List_Pending.length > 1 ? "Pending registration requests" : "Pending registration request"} />
                        :
                        ""
                }
                {
                    Accounts_List_Approved.length > 0 ?
                        <UI_Card Shape="Rectangle" Figure={Accounts_List_Approved.length} Color="Green" Text={Accounts_List_Approved.length > 1 ? "Active accounts" : "Active account"} />
                        :
                        ""
                }
                {
                    (Accounts_List_Rejected.length + Accounts_List_Deactivated.length) > 0 ?
                        <UI_Card Shape="Rectangle" Figure={(Accounts_List_Rejected.length + Accounts_List_Deactivated.length)} Color="Orange" Text={(Accounts_List_Rejected.length + Accounts_List_Deactivated.length) > 1 ? "Rejected/deactivated accounts" : "Rejected/deactivated account"} />
                        :
                        ""
                }
                {
                    (Accounts_List_Rejected.length +
                        Accounts_List_Deactivated.length +
                        Accounts_List_Approved.length +
                        Accounts_List_Pending.length) > 0 ?
                        <UI_Card Shape="Rectangle" Figure={(Accounts_List_Rejected.length +
                            Accounts_List_Deactivated.length +
                            Accounts_List_Approved.length +
                            Accounts_List_Pending.length
                        )}
                            Text={(
                                Accounts_List_Rejected.length +
                                Accounts_List_Deactivated.length +
                                Accounts_List_Approved.length +
                                Accounts_List_Pending.length
                            ) > 1 ? "Total accounts" : "Total account"} />
                        :
                        ""
                }


            </div>
            <div style={{ display: "grid", gridTemplateColumns: "0px 500px auto", marginBottom: "10px" }}>
                <UI_Input_Text id="AM_SearchBar" Input_Type="Text"
                    Label_Text="Search" Input_Placeholder="Enter search terms (e.g., name, email, status, etc.)" onInput={handleFocus} onBlur={handleBlur} onClick={handleFocus} />
            </div>

            <div className='AM' State={Accounts_ChangeInProgress == true ? "Inactive" : "Active"}>
                {Search_Mode == false ?
                    <>
                        {Accounts_List_Pending.length !== 0 && Search_Mode == false ?
                            <>
                                <h2 className='General_Title'>
                                    {Accounts_List_Pending.length} account(s) pending approval
                                </h2>
                                <table className='AM_Table'>
                                    <thead>
                                        <tr className='AM_Table_Row' Type="Primary">
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Name
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Email
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Date created
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Status
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Controls
                                                </p>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Accounts_List_Pending.map(acc => (
                                            <Table_Item Data={acc} key={acc._id} />
                                            // <tr className='AM_Table_Row' key={acc._id} Selected={Accounts_Selected?._id == acc._id ? "true" : "false"}>
                                            //     <td className='AM_Table_Cell'>
                                            //         <p className='AM_Table_Cell_Data'>
                                            //             {acc.Name.First} {acc.Name.MI ? `${acc.Name.MI}.` : ""} {acc.Name.Last}
                                            //         </p>
                                            //     </td>
                                            //     <td className='AM_Table_Cell'>
                                            //         <p className='AM_Table_Cell_Data'>
                                            //             {acc.Email}
                                            //         </p>
                                            //     </td>
                                            //     <td className='AM_Table_Cell'>
                                            //         <p className='AM_Table_Cell_Data'>
                                            //             {window.Date_Format(new Date(acc.Approval.DateApproved))}
                                            //         </p>
                                            //     </td>
                                            //     <td className='AM_Table_Cell'>
                                            //         {acc._id}
                                            //         {acc.Approval.State === "Approved" ?
                                            //             <p className='AM_Table_Cell_Data'>
                                            //                 Active
                                            //             </p>
                                            //             :
                                            //             <p className='AM_Table_Cell_Data'>
                                            //                 Pending approval
                                            //             </p>
                                            //         }
                                            //     </td>
                                            //     <td className='AM_Table_Cell'>
                                            //         <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                            //             <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(acc._id)} Hover_Text="View account details" />
                                            //             <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Approve(acc._id)} Hover_Text="Approve account request" />
                                            //             <UI_Button Icon={Icon_Reject} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reject(acc._id)}
                                            //                 Hover_Text="Reject account request" />
                                            //         </UI_LinearGroup>

                                            //     </td>
                                            // </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </>
                            :
                            ""
                        }

                        {Accounts_List_Approved.length !== 0 ?
                            <>
                                <h2 className='General_Title'>
                                    {Accounts_List_Approved.length} active account(s)
                                </h2>
                                <table className='AM_Table'>
                                    <thead>
                                        <tr className='AM_Table_Row' Type="Primary">
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Name
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Email
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Date created
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Role
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Controls
                                                </p>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Accounts_List_Approved.map(acc => (
                                            <Table_Item Data={acc} key={acc._id} />
                                        ))}
                                    </tbody>
                                </table>
                            </>
                            :

                            ""
                        }

                        {Accounts_List_Rejected.length + Accounts_List_Deactivated.length !== 0 ?
                            <>
                                <h2 className='General_Title'>
                                    {Accounts_List_Rejected.length + Accounts_List_Deactivated.length} rejected and/or deactivated account(s)
                                </h2>
                                <table className='AM_Table'>
                                    <thead>
                                        <tr className='AM_Table_Row' Type="Primary">
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Name
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Email
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Date rejected/deactivated
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Status
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    Controls
                                                </p>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Accounts_List_Rejected.map(acc => (
                                            <Table_Item Data={acc} key={acc._id} />
                                        ))}

                                        {Accounts_List_Deactivated.map(acc => (
                                            <Table_Item Data={acc} key={acc._id} />
                                        ))}
                                    </tbody>
                                </table>
                            </>
                            :
                            ""
                        }
                    </>
                    :
                    <>
                        <h3 className='General_Paragraph'>
                            Search results for '{Search_Query}'
                        </h3>
                        <table className='AM_Table'>
                            {Accounts_List_Filtered_Pending.length !== 0 && Search_Mode == true ?
                                <>
                                    {Accounts_List_Filtered_Pending.map(acc => (
                                        <>
                                            <tr className='AM_Table_Row' key={acc._id} Selected={Accounts_Selected?._id == acc._id ? "true" : "false"}>
                                                <td className='AM_Table_Cell'>
                                                    <p className='AM_Table_Cell_Data'>
                                                        {acc.Name.First} {acc.Name.MI ? `${acc.Name.MI}.` : ""} {acc.Name.Last}
                                                    </p>
                                                </td>
                                                <td className='AM_Table_Cell'>
                                                    <p className='AM_Table_Cell_Data'>
                                                        {acc.Email}
                                                    </p>
                                                </td>
                                                <td className='AM_Table_Cell'>
                                                    <p className='AM_Table_Cell_Data'>
                                                        {window.Date_Format(new Date(acc.Approval.DateApproved))}
                                                    </p>
                                                </td>
                                                <td className='AM_Table_Cell'>
                                                    {acc.Approval.State === "Approved" ?
                                                        <p className='AM_Table_Cell_Data'>
                                                            Active
                                                        </p>
                                                        :
                                                        <p className='AM_Table_Cell_Data'>
                                                            Pending approval
                                                        </p>
                                                    }
                                                </td>
                                                <td className='AM_Table_Cell'>
                                                    <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                        <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(acc._id)} />
                                                        <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Approve(acc._id)} />
                                                        <UI_Button Icon={Icon_Reject} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reject(acc._id)} />
                                                    </UI_LinearGroup>

                                                </td>
                                            </tr>
                                        </>


                                    ))}
                                </>
                                :
                                ""
                            }



                            {Accounts_List_Filtered_Approved.length !== 0 ?
                                <>
                                    {Accounts_List_Filtered_Approved.map(acc => (
                                        <tr className='AM_Table_Row' key={acc._id} Selected={Accounts_Selected?._id == acc._id ? "true" : "false"}>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Name.First} {acc.Name.MI ? `${acc.Name.MI}.` : ""} {acc.Name.Last}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Email}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {window.Date_Format(new Date(acc.Approval.DateApproved))}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                {acc.Approval.State === "Approved" ?
                                                    <p className='AM_Table_Cell_Data'>
                                                        {Permission_CheckPattern(acc)}
                                                    </p>
                                                    :
                                                    <p className='AM_Table_Cell_Data'>
                                                        Pending approval
                                                    </p>
                                                }
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(acc._id)} />
                                                    <UI_Button Icon={Icon_Edit} Type="Icon" Icon_Position="Center" OnClick={() => Account_Edit(acc._id)} />
                                                    <UI_Button Icon={Icon_Reject} Type="Icon" Icon_Position="Center" OnClick={() => Account_Deactivate(acc._id)} />
                                                </UI_LinearGroup>
                                            </td>
                                        </tr>
                                    ))}
                                </>
                                :

                                ""
                            }

                            {Accounts_List_Filtered_Rejected.length + Accounts_List_Filtered_Deactivated.length !== 0 ?
                                <>
                                    {Accounts_List_Filtered_Rejected.map(acc => (
                                        <tr className='AM_Table_Row' key={acc._id} Selected={Accounts_Selected?._id == acc._id ? "true" : "false"}>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Name.First} {acc.Name.MI ? `${acc.Name.MI}.` : ""} {acc.Name.Last}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Email}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {window.Date_Format(new Date(acc.Approval.DateApproved))}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                {acc.Approval.State === "Rejected" ?
                                                    <p className='AM_Table_Cell_Data'>
                                                        Rejected
                                                    </p>
                                                    :
                                                    <>
                                                        {acc.Approval.State === "Deactivated" ?
                                                            <p className='AM_Table_Cell_Data'>
                                                                Deactivated
                                                            </p>
                                                            :
                                                            <p className='AM_Table_Cell_Data'>
                                                                Status unknown
                                                            </p>
                                                        }
                                                    </>
                                                }
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(acc._id)} />
                                                    <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reinstate(acc._id)} />
                                                    <UI_Button Icon={Icon_Delete} Type="Icon" Icon_Position="Center" OnClick={() => Account_Delete(acc._id)} />
                                                </UI_LinearGroup>
                                            </td>
                                        </tr>
                                    ))}

                                    {Accounts_List_Filtered_Deactivated.map(acc => (
                                        <tr className='AM_Table_Row' key={acc._id} Selected={Accounts_Selected?._id == acc._id ? "true" : "false"}>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Name.First} {acc.Name.MI ? `${acc.Name.MI}.` : ""} {acc.Name.Last}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {acc.Email}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <p className='AM_Table_Cell_Data'>
                                                    {window.Date_Format(new Date(acc.Approval.DateApproved))}
                                                </p>
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                {acc.Approval.State === "Rejected" ?
                                                    <p className='AM_Table_Cell_Data'>
                                                        Rejected
                                                    </p>
                                                    :
                                                    <>
                                                        {acc.Approval.State === "Deactivated" ?
                                                            <p className='AM_Table_Cell_Data'>
                                                                Deactivated
                                                            </p>
                                                            :
                                                            <p className='AM_Table_Cell_Data'>
                                                                Status unknown
                                                            </p>
                                                        }
                                                    </>
                                                }
                                            </td>
                                            <td className='AM_Table_Cell'>
                                                <UI_LinearGroup Direction="Row" Gap="None" Fill>
                                                    <UI_Button Icon={Icon_View} Type="Icon" Icon_Position="Center" OnClick={() => Account_Fetch(acc._id)} />
                                                    <UI_Button Icon={Icon_Approve} Type="Icon" Icon_Position="Center" OnClick={() => Account_Reactivate(acc._id)} />
                                                </UI_LinearGroup>
                                            </td>
                                        </tr>
                                    ))}
                                </>
                                :
                                ""
                            }
                        </table>
                    </>
                }


            </div>
        </div >


    );

}


